/**
 * Task FF: owner notification recipients (通知设置) + permission editor (权限设置).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["ff.tab.alerts","Notifications","通知设置"],
  ["ff.tab.permissions","Permissions","权限设置"],
  ["ff.tab.customerMessages","Customer messages","顾客消息"],
  ["ff.n.title","Who gets notified","谁会收到通知"],
  ["ff.n.intro","Choose which e-mail addresses hear about each event. Without changes, everything goes to your login e-mail. Branch events can also go to that branch's manager.","为每种事件选择接收通知的邮箱。未修改时全部发送到您的登录邮箱。分店事件还可以另外发给该分店的店长。"],
  ["ff.n.sender","Sent as {from}","发件人：{from}"],
  ["ff.n.senderPending","Platform e-mail is being set up — notifications are sent by the system mailer for now.","平台邮件仍在设置中——目前由系统邮箱代发通知。"],
  ["ff.n.test","Send test e-mail","发送测试邮件"],
  ["ff.n.testTo","Send a test to","测试邮件发送到"],
  ["ff.n.testSent","Test e-mail sent to {to}","测试邮件已发送到 {to}"],
  ["ff.n.testFailed","Could not send to {to}","无法发送到 {to}"],
  ["ff.n.on","On","开启"],
  ["ff.n.off","Off","关闭"],
  ["ff.n.recipients","Send to","发送到"],
  ["ff.n.recipientsHint","E-mail addresses, separated by commas or new lines.","邮箱地址，用逗号或换行分隔。"],
  ["ff.n.byBranch","Also send per branch","按分店另外发送"],
  ["ff.n.byBranchHint","For events of this branch only (e.g. the branch manager).","只针对该分店的事件（例如分店店长）。"],
  ["ff.n.default","Default","默认"],
  ["ff.n.saved","Notification settings saved","通知设置已保存"],
  ["ff.n.edit","Change","修改"],
  ["ff.n.nobody","Nobody","无人接收"],
  ["ff.n.unavailable","Not in your plan","当前套餐未包含"],
  ["ff.n.invalid","Check these addresses: {list}","请检查这些邮箱：{list}"],
  ["ff.grp.team","Team requests","员工申请"],
  ["ff.grp.sales","Online shop","网店"],
  ["ff.grp.bookings","Online bookings","网上预约"],
  ["ff.grp.subscriptions","Subscriptions","订阅"],
  ["ff.grp.stock","Stock","库存"],
  ["ff.grp.account","Account & website","账户与官网"],
  ["ff.ev.claim_submitted","Expense claim submitted","员工提交报销"],
  ["ff.ev.leave_submitted","Leave request submitted","员工提交请假"],
  ["ff.ev.bank_change_requested","Bank details change request","银行资料修改申请"],
  ["ff.ev.shop_order","Online shop order placed","网店新订单"],
  ["ff.ev.booking_online_new","New online booking","新的网上预约"],
  ["ff.ev.booking_online_cancelled","Online booking cancelled by the customer","顾客在网上取消预约"],
  ["ff.ev.subscription_new","New subscription","新订阅"],
  ["ff.ev.subscription_changed","Subscription plan changed","订阅方案变更"],
  ["ff.ev.subscription_cancelled","Subscription cancelled","订阅取消"],
  ["ff.ev.subscription_payment_failed","Subscription payment failed","订阅扣款失败"],
  ["ff.ev.low_stock","Low stock (reorder point reached)","库存不足（达到补货点）"],
  ["ff.ev.domain_broken","Website address stopped working","官网域名失效"],
  ["ff.ev.billing_payment_failed","Senvia POS plan payment failed","Senvia POS 套餐扣款失败"],
  ["ff.p.title","What each role can see and do","每个角色能看到和操作什么"],
  ["ff.p.intro","Pick a level per page group. Hidden pages disappear from the menu and are blocked on the server too. Nothing changes until you edit something; the owner always has full access.","为每组页面选择权限。设为不可见的页面会从菜单消失，服务器也会拒绝访问。不修改就保持现在的设定；店主永远拥有全部权限。"],
  ["ff.p.module","Page group","页面"],
  ["ff.p.lv.none","Hidden","不可见"],
  ["ff.p.lv.view","View only","只看"],
  ["ff.p.lv.edit","Can edit","可编辑"],
  ["ff.p.lv.manage","Full control","可管理"],
  ["ff.p.lvHint.none","The pages are hidden.","页面隐藏。"],
  ["ff.p.lvHint.view","Open and read.","可以打开查看。"],
  ["ff.p.lvHint.edit","Also add and change.","还可以新增和修改。"],
  ["ff.p.lvHint.manage","Also approve, delete and export.","还可以审批、删除和导出。"],
  ["ff.p.role.owner","Owner","店主"],
  ["ff.p.role.manager","Manager","店长"],
  ["ff.p.role.cashier","Front desk","收银"],
  ["ff.p.role.staff","Staff","员工"],
  ["ff.p.ownerFull","Always full","始终全部"],
  ["ff.p.changed","Changed","已修改"],
  ["ff.p.copy","Copy role","复制角色"],
  ["ff.p.copyFrom","Copy all levels from","复制以下角色的全部设置"],
  ["ff.p.copyDone","{role} now has the same levels as {from}","{role} 已复制 {from} 的设置"],
  ["ff.p.reset","Restore defaults","恢复默认"],
  ["ff.p.resetConfirm","Restore the default levels of {role}?","恢复 {role} 的默认权限？"],
  ["ff.p.resetDone","Defaults restored","已恢复默认"],
  ["ff.p.saved","Permission saved","权限已保存"],
  ["ff.p.people","Individual exceptions","个人例外"],
  ["ff.p.peopleIntro","Give one person different levels than their role (e.g. a senior team member who may see reports).","为某个人单独设置与其角色不同的权限（例如可以看报表的资深员工）。"],
  ["ff.p.followRole","Same as role ({level})","跟随角色（{level}）"],
  ["ff.p.exceptions","{n} exceptions","{n} 项例外"],
  ["ff.p.noExceptions","Same as role","跟随角色"],
  ["ff.p.editPerson","Permissions for {name}","{name} 的权限"],
  ["ff.p.save","Save","保存"],
  ["ff.p.ownerOnly","Only the owner can change permissions.","只有店主可以修改权限。"],
  ["ff.mod.pos","Checkout (POS)","收银"],
  ["ff.mod.appointments","Bookings & calendar","预约/日历"],
  ["ff.mod.customers","Customers","顾客"],
  ["ff.mod.membership","Membership & rewards","会员/配套"],
  ["ff.mod.subscriptions","Subscriptions","订阅"],
  ["ff.mod.inventory","Products & stock","产品/库存"],
  ["ff.mod.team","Team","员工/团队"],
  ["ff.mod.attendance","Attendance","考勤"],
  ["ff.mod.payroll","Payroll","工资管理"],
  ["ff.mod.requests","Claims & leave approval","报销/请假审核"],
  ["ff.mod.branches","Branches","分店管理"],
  ["ff.mod.reports","Reports","报表"],
  ["ff.mod.finance","Finance & expenses","财务/费用"],
  ["ff.mod.online","Website & online shop","官网与网店"],
  ["ff.mod.marketing","Marketing","营销"],
  ["ff.mod.settings","Settings","设置"],
  ["ff.modHint.pos","Ring up sales and use the cash drawer; full control also approves refunds and big discounts.","收银、开钱箱；可管理还能审批退款和大额折扣。"],
  ["ff.modHint.appointments","See the calendar; edit = book, move and cancel.","查看日历；可编辑＝预约、改期和取消。"],
  ["ff.modHint.customers","Customer list and profiles; full control also imports customers.","顾客名单和资料；可管理还能导入顾客。"],
  ["ff.modHint.membership","Adjust points and vouchers; full control also changes membership rules and rewards.","调整积分和优惠券；可管理还能修改会员规则和奖励。"],
  ["ff.modHint.subscriptions","See subscriptions; edit = sell, cancel and switch; full control also edits the plans.","查看订阅；可编辑＝售卖、取消和改方案；可管理还能编辑订阅方案。"],
  ["ff.modHint.inventory","Services, products and stock; full control also suppliers and purchase orders.","服务、商品和库存；可管理还包括供应商和采购单。"],
  ["ff.modHint.team","See the team list.","查看团队名单。"],
  ["ff.modHint.attendance","See and correct clock-ins.","查看和修正打卡。"],
  ["ff.modHint.payroll","Run payroll, commission plans and salaries.","计算工资、提成方案和底薪。"],
  ["ff.modHint.requests","Approve or reject expense claims, leave and bank-detail changes.","审批报销、请假和银行资料修改。"],
  ["ff.modHint.branches","See branches; full control also manages them.","查看分店；可管理还能管理分店。"],
  ["ff.modHint.reports","Sales and performance reports; full control also exports data.","销售和业绩报表；可管理还能导出数据。"],
  ["ff.modHint.finance","Daily close and P&L; edit = expenses; full control also pays suppliers and locks days.","日结和损益；可编辑＝费用；可管理还能付款给供应商和锁定日结。"],
  ["ff.modHint.online","Website builder and online shop settings.","官网编辑和网店设置。"],
  ["ff.modHint.marketing","Broadcasts, automations and the AI helper.","群发消息、自动化和 AI 助手。"],
  ["ff.modHint.settings","Salon settings, plan & billing and the audit log.","店铺设置、套餐账单和操作记录。"],
] as const;

export type FfKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<FfKey, string>;

export const taskFF = { en: col(1), zh: col(2), ms: col(1) };
